import { useLanguage } from '../contexts/LanguageContext';
import { en } from '../translations/en';
import { ar } from '../translations/ar';
import { fr } from '../translations/fr';

const translations = {
  en,
  ar,
  fr,
};

export const useTranslation = () => {
  const { language } = useLanguage();

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        return key; // Return key if translation not found
      }
    }
    
    return value !== undefined && value !== null ? value : key;
  };

  return { t, language };
};
